import React from 'react';

export default function EquipmentImage({ image }) {
  return <div className="equipment-machine-image">
    <img src={image.src} width={image.width} height={image.height} alt={image.alt} />
  </div>;
}
